import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { BsCurrencyRupee } from 'react-icons/bs';
import moment from 'moment';
import { AiOutlineSearch } from 'react-icons/ai';
import CustomPagination from '../../Pages/Wallet/CustomPagination';
import { InputBase, Typography } from '@mui/material';
import { Box } from 'react-bootstrap-icons';
import CustomNoRowsOverlay from '../../PageComponent/PlaceholderDatatable';

function WithdrawalTable({ data }) {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const pageSize = 10;

    const rows = data.map((withdraw, index) => ({
        id: index + 1,
        requestDate: withdraw?.createdAt,
        paidDate: withdraw?.paidDate,
        withdrawAmt: withdraw?.withdrawAmt,
        remainingSavingAmt: withdraw?.remainingSavingAmt,
        status: withdraw?.status,
    }));

    const filteredRows = rows.filter((row) =>
        Object.values(row).some((val) =>
            String(val).toLowerCase().includes(search.toLowerCase())
        )
    );

    const paginatedRows = filteredRows.slice(page * pageSize, (page + 1) * pageSize);
    const totalPages = Math.ceil(filteredRows.length / pageSize);

    const columns = [
        {
            field: 'requestDate',
            headerName: 'Request Date',
            flex: 1,
            renderCell: ({ value }) => moment(value).format('DD-MM-YYYY'),
        },
        {
            field: 'paidDate',
            headerName: 'Withdraw Date',
            flex: 1,
            renderCell: ({ row }) =>
                row.status === 'Paid' ? moment(row.paidDate).format('DD-MM-YYYY') : '--',
        },
        {
            field: 'withdrawAmt',
            headerName: 'Amount',
            flex: 1,
            renderCell: ({ value }) => (
                <span className="flex items-center">
                    <BsCurrencyRupee className="mr-1" />
                    {value}
                </span>
            ),
        },
        // {
        //     field: 'remainingSavingAmt',
        //     headerName: 'Balance',
        //     flex: 1,
        //     renderCell: ({ value }) => (
        //         <span className="flex items-center">
        //             <BsCurrencyRupee className="mr-1" />
        //             {value}
        //         </span>
        //     ),
        // },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1
        },
    ];

    return (
        <div className="p-4">
            <div className="flex justify-between items-center px-4 py-2 bg-[#f3f8ff] rounded-t-lg">
                <p className='text-coalBlack headingText capitalize'>Withdraw History</p>
                <div className="w-[300px] flex items-center gap-2 border border-slate-300 rounded px-2 py-1 bg-white">
                    <AiOutlineSearch className="text-slate-500" />
                    <InputBase
                        placeholder="Search"
                        className="text-sm"
                        value={search}
                        onChange={(e) => {
                            setPage(0);
                            setSearch(e.target.value);
                        }}
                    />
                </div>
            </div>
            {/* Table */}
            <DataGrid
                rows={paginatedRows}
                columns={columns}
                autoHeight
                hideFooter
                disableColumnMenu
                disableRowSelectionOnClick
                disableColumnSorting
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                sx={{
                     fontFamily: 'var(--font-family)', 
                    '--DataGrid-overlayHeight': '80px',
                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                        outline: 'none',
                    },
                    '& .MuiDataGrid-cell:focus': {
                        outline: 'none',
                    },
                    '& .MuiDataGrid-cell:focus-within': {
                        outline: 'none',
                    },
                    '& .MuiDataGrid-cell--withRenderer': {
                        padding: '8px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#ffff',
                        borderBottom: '1px solid #e2e8f0',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 'bold',
                    },
                }}

            />

            {/* Pagination */}
            <CustomPagination page={page} totalPages={totalPages} setPage={setPage} />
        </div>
    );
}

export default WithdrawalTable;
